import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent, IonLabel } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00043ModeRegulation } from '../../../Enum/P00043ModeRegulation';
import { P00043ConsigneTemperatureEnum } from '../../../Enum/P00043ConsigneTemperatureEnum';

@Component({
  selector: 'app-p00043-pac-mise-en-oeuvre-regulation',
  templateUrl: './p00043-pac-mise-en-oeuvre-regulation.component.html',
  styleUrls: ['./p00043-pac-mise-en-oeuvre-regulation.component.scss'],
  imports: [
    AffichageWarningComponent,
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    IonLabel,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    TranslatePipe,
  ],
})
export class P00043PacMiseEnOeuvreRegulationComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00043ModeRegulation = P00043ModeRegulation;
  protected readonly P00043ConsigneTemperatureEnum =
    P00043ConsigneTemperatureEnum;
}
